<template>
  <v-layout row wrap class="my-5" align-center>
    <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 lg4 offset-lg4>
        <div
          class="font-weight-black text-h4 text-center text-uppercase transition-swing mb-10"
          v-text="'Downloads RLR'"
        ></div>
        <template v-if="isLandingPageVisible">
          <v-row>
            <v-col cols="12">
              <div class="transition-swing mb-4">
                Selecteaza resursa pe care doresti sa o descarci.
              </div>
            </v-col>
          </v-row>
          <v-row v-if="loadingFiles" justify="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-row>
          <v-row v-else-if="availableFiles.length === 0">
            <v-col cols="12">
              Nu exista resurse disponibile momentan.
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col v-for="file in availableFiles" :key="file.id" cols="12">
              <v-card outlined>
                <v-card-title>{{ file.displayName }}</v-card-title>
                <v-card-actions>
                  <v-btn
                    color="primary"
                    :disabled="!file.available"
                    @click="selectFile(file.id)"
                  >
                    <v-icon left>mdi-download</v-icon>
                    {{ file.available ? 'Descarca' : 'Indisponibil' }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert type="info" text class="mt-6">
                <p>
                  Mod-urile prezente sunt creații originale realizate de Luchian, destinate membrilor comunității RLR (<a href="https://discord.gg/auYrYrFAns" target="_blank" rel="noopener noreferrer">Discord RLR</a>) si sunt oferite gratuit pentru uz personal. 
                </p>
                <p>
                  Utilizarea publică în afara comunității RLR — cum ar fi servere multiplayer publice, competiții, ligi sau evenimente — precum și orice formă de utilizare comercială, directă sau indirectă, este interzisă fără acordul explicit al Racing League Romania / autorului. Mod-urile nu pot fi utilizate în cadrul niciunei activități, platforme, competiții sau servicii pentru care se percep taxe, contribuții, abonamente, donații condiționate sau orice altă formă de plată, indiferent de natura sau modalitatea acesteia, fără acordul prealabil și explicit al autorului.
                </p>
                <p>
                  Redistribuirea, modificarea, reutilizarea sau includerea acestui conținut în alte proiecte ori lucrări derivate este interzisă fără acordul prealabil și explicit al autorului. Fișierele nu pot fi vândute, închiriate, transferate, sublicențiate sau găzduite pe alte platforme, site-uri, servere ori servicii de stocare.
                </p>
                <p class="font-weight-bold">
                  TL;DR: fii om cu obraz.
                </p>
                <p class="mb-0">
                  Descărcarea și utilizarea acestor mod-uri presupun acceptarea condițiilor de mai sus. Mulțumim, distracție plăcută.
                </p>
                <p>
                </p>
                <p>
                  Sportiv, Racing League Romania.
                </p>
              </v-alert>
            </v-col>
          </v-row>
        </template>
        <v-row v-if="isLoginVisible">
          <v-col :cols="12">
            <div
              class="transition-swing mb-10"
              v-text="'Pentru a obtine continut realizat de Racing League Romania, trebuie sa te autentifici cu Discord si sa fii membru pe serverul Racing League Romania.'"
            ></div>
          </v-col>
        </v-row>
        <v-row v-if="isLoginVisible">
          <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 3">
            <v-btn color="primary" @click.native="loginDiscord">
              <v-icon left dark>mdi-discord</v-icon>
              Autentificare Discord
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row v-if="isDownloadLinkVisible">
          <v-col :cols="12">
            <div class="transition-swing mb-10">
              <p>Download-ul va incepe imediat. Daca nu incepe, <a :href="downloadLinkHref" target="_blank">apasati aici</a>.</p>
            </div>
          </v-col>
        </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
  import {mapActions} from 'vuex'
  
  export default {
    pageTitle: 'Downloads RLR',
    
    components: {},
    
    data () {
      return {
        downloadLinkVisible: false,
        downloadLink: null,
        requestedFile: null,
        availableFiles: [],
        loadingFiles: false
      }
    },
    
    watch: {
      '$route.query.file'(fileId) {
        this.requestedFile = fileId || null;
        if (!this.requestedFile && this.availableFiles.length === 0) {
          this.getAvailableFiles();
        }
      }
    },

    computed: {
      downloadLinkHref() {
        return this.downloadLink;
      },

      isDownloadLinkVisible() {
        return this.downloadLinkVisible;
      },

      isLoginVisible() {
        return !!this.requestedFile && !this.downloadLinkVisible;
      },

      isLandingPageVisible() {
        return !this.requestedFile && !this.downloadLinkVisible;
      }
    },

    methods: {
      ...mapActions('app', ['showSnackbar']),

      async getAvailableFiles() {
        this.loadingFiles = true;
        try {
          const response = await this.$http.get('/download/available-files');
          this.availableFiles = response.data;
        } catch (error) {
          this.showSnackbar({
            timeout: 10000,
            content: "Lista de resurse nu a putut fi incarcata",
            color: "error",
            value: true,
          });
        } finally {
          this.loadingFiles = false;
        }
      },

      selectFile(fileId) {
        this.requestedFile = fileId;
        this.$router.push({ path: '/download', query: { file: fileId } });
      },

      loginDiscord() {
        // Include the file parameter if specified
        // Acest lucru ne ajuta sa oferim continut exclusiv membrilor nostri. Lista de resurse disponibile astazi: Motorpark, Transilvania Motor Ring, Logan Cup.
        const fileParam = this.requestedFile ? `?file=${encodeURIComponent(this.requestedFile)}` : '';
        window.location = `${process.env.VUE_APP_API_SCHEMA}${process.env.VUE_APP_API_HOST}/download/discord-auth${fileParam}`
      }
    },

    mounted() {
      // Get the requested file from query parameters
      this.requestedFile = this.$route.query.file;

      if (!this.requestedFile) {
        this.getAvailableFiles();
      }

      var errMsg = null;
      switch(this.$route.query.err) {
        case 'AuthFailure': errMsg = "Autentificare esuata"; break;
        case 'NotMember': errMsg = "Utilizatorul nu este membru pe serverul Racing League Romania"; break;
        case 'BadToken': errMsg = "Token invalid, incearca autentificarea din nou"; break;
        case 'FileNotFound': errMsg = "Fisierul solicitat nu este disponibil"; break;
        case 'FileNotAvailable': errMsg = "Fisierul solicitat nu este disponibil pe server"; break;
      }

      if (errMsg) {
          this.showSnackbar({
            timeout: 30000,
            content: errMsg,
            color: "error",
            value: true,
          });
          return;
      }

      const downloadToken = this.$route.query.downloadToken;
      if (typeof downloadToken !== 'undefined') {
        this.downloadLinkVisible = true;
        // Include the file parameter in the download link if specified
        const fileParam = this.$route.query.file ? `&file=${encodeURIComponent(this.$route.query.file)}` : '';
        this.downloadLink = `${process.env.VUE_APP_API_SCHEMA}${process.env.VUE_APP_API_HOST}/download/authenticated-get?token=${downloadToken}${fileParam}`;
        window.open(this.downloadLink, "_blank");
      }
      else {
        this.downloadLinkVisible = false;
      }
    }
  }
</script>
